import { secondsToMilliseconds } from 'date-fns';
import { queryOptions } from '@tanstack/react-query';

import { getPriceBreakdown, getQuote } from 'services/backend/prices';
import { RateTierService } from 'types/domainModels';

export const pricesQueries = {
  getQuote: (data: {
    incidence: number | null;
    questionCount: number | null;
    respondentsCount: number;
    services: RateTierService[];
    multiplierOptions: number[];
    version?: number;
  }) =>
    queryOptions({
      enabled:
        data.respondentsCount > 0 &&
        data.incidence !== null &&
        data.questionCount !== null,
      queryFn: () => {
        if (data.incidence === null || data.questionCount === null) {
          throw new Error('Incidence and question count must be provided');
        }

        return getQuote({
          data: {
            incidence: data.incidence,
            questionCount: data.questionCount,
            respondentsCount: data.respondentsCount,
            services: data.services,
            multiplierOptions: data.multiplierOptions,
            version: data.version,
          },
        });
      },
      queryKey: ['quotes', data],
      staleTime: secondsToMilliseconds(2),
    }),
  getPriceBreakdown: (data: {
    incidence: number | null;
    questionCount: number | null;
    respondentsCount: number;
    multiplierOptions: number[];
  }) =>
    queryOptions({
      enabled:
        data.respondentsCount > 0 &&
        data.incidence !== null &&
        data.questionCount !== null,
      queryFn: () => {
        if (data.incidence === null || data.questionCount === null) {
          throw new Error('Incidence and question count must be provided');
        }

        return getPriceBreakdown({
          data: {
            incidence: data.incidence,
            questionCount: data.questionCount,
            respondentsCount: data.respondentsCount,
            multiplierOptions: data.multiplierOptions,
          },
        });
      },
      queryKey: ['priceBreakdown', data],
      staleTime: secondsToMilliseconds(2),
    }),
};
